import React from 'react'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import HelpText from '../EngagementButtons/HelpText'
import classnames from 'clsx'
import { useMediaQuery } from '@material-ui/core'

const ClosedCaptions = ({ text, mobile }) => {
  const classes = useStyles()

  const isMobile = useMediaQuery('(max-width: 767px)')
  const popoutMode = useSelector(state => state.window.popoutMode)

  return (
    <div
      className={classnames(classes.captions, {
        [classes.mobile]: isMobile,
        [classes.popoutMode]: popoutMode
      })}
    >
      <HelpText
        className={classnames(classes.captionText, {
          [classes.captionTextMobile]: isMobile
        })}
      >
        {text
          .split('')
          .reverse()
          .slice(0, 100)
          .reverse()
          .join('')}
      </HelpText>
    </div>
  )
}

export default ClosedCaptions



// WEBPACK FOOTER //
// ./src/components/ClosedCaptions/index.jsx